/* tslint:disable */
/* eslint-disable */
/* @relayHash 59c4fc70c110ea3b1e486b01f5c508f4 */

import { ConcreteRequest } from "relay-runtime";
export type QWEEntryStatus = "draft" | "signedoff" | "submitted" | "%future added value";
export type PortfolioPageQueryRendererQueryVariables = {
    uuid?: string | null;
    searchText?: string | null;
};
export type PortfolioPageQueryRendererQueryResponse = {
    readonly candidate: {
        readonly id: string;
        readonly firstName: string;
        readonly lastName: string;
        readonly placements: {
            readonly edges: ReadonlyArray<{
                readonly id: string;
                readonly name: string;
                readonly entries: {
                    readonly edges: ReadonlyArray<{
                        readonly id: string;
                        readonly title: string;
                        readonly startDate: string;
                        readonly endDate: string;
                        readonly status: QWEEntryStatus | null;
                        readonly placement: {
                            readonly name: string;
                        } | null;
                        readonly fileUrl: string | null;
                    } | null> | null;
                } | null;
            } | null> | null;
        } | null;
    } | null;
};
export type PortfolioPageQueryRendererQuery = {
    readonly response: PortfolioPageQueryRendererQueryResponse;
    readonly variables: PortfolioPageQueryRendererQueryVariables;
};



/*
query PortfolioPageQueryRendererQuery(
  $uuid: UUID
  $searchText: String
) {
  candidate(uuid: $uuid) {
    id
    firstName
    lastName
    placements {
      edges {
        id
        name
        entries(filter: {title: $searchText}) {
          edges {
            id
            title
            startDate
            endDate
            status
            placement {
              name
              id
            }
            fileUrl
          }
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "uuid",
            "type": "UUID",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "searchText",
            "type": "String",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "uuid",
            "variableName": "uuid"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "firstName",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "lastName",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v6 = [
        ({
            "kind": "ObjectValue",
            "name": "filter",
            "fields": [
                {
                    "kind": "Variable",
                    "name": "title",
                    "variableName": "searchText"
                }
            ]
        } as any)
    ], v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "startDate",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "endDate",
        "args": null,
        "storageKey": null
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "status",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "fileUrl",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "PortfolioPageQueryRendererQuery",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "candidate",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Candidate",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        (v3 /*: any*/),
                        (v4 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "placements",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PlacementPage",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Placement",
                                    "plural": true,
                                    "selections": [
                                        (v2 /*: any*/),
                                        (v5 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "entries",
                                            "storageKey": null,
                                            "args": (v6 /*: any*/),
                                            "concreteType": "EntryPage",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "QWEEntry",
                                                    "plural": true,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v7 /*: any*/),
                                                        (v8 /*: any*/),
                                                        (v9 /*: any*/),
                                                        (v10 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "placement",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Placement",
                                                            "plural": false,
                                                            "selections": [
                                                                (v5 /*: any*/)
                                                            ]
                                                        },
                                                        (v11 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "PortfolioPageQueryRendererQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "candidate",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Candidate",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        (v3 /*: any*/),
                        (v4 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "placements",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PlacementPage",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Placement",
                                    "plural": true,
                                    "selections": [
                                        (v2 /*: any*/),
                                        (v5 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "entries",
                                            "storageKey": null,
                                            "args": (v6 /*: any*/),
                                            "concreteType": "EntryPage",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "QWEEntry",
                                                    "plural": true,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v7 /*: any*/),
                                                        (v8 /*: any*/),
                                                        (v9 /*: any*/),
                                                        (v10 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "placement",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Placement",
                                                            "plural": false,
                                                            "selections": [
                                                                (v5 /*: any*/),
                                                                (v2 /*: any*/)
                                                            ]
                                                        },
                                                        (v11 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "PortfolioPageQueryRendererQuery",
            "id": null,
            "text": "query PortfolioPageQueryRendererQuery(\n  $uuid: UUID\n  $searchText: String\n) {\n  candidate(uuid: $uuid) {\n    id\n    firstName\n    lastName\n    placements {\n      edges {\n        id\n        name\n        entries(filter: {title: $searchText}) {\n          edges {\n            id\n            title\n            startDate\n            endDate\n            status\n            placement {\n              name\n              id\n            }\n            fileUrl\n          }\n        }\n      }\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '3afdd94eeb52b912d3dd258fb00b15c7';
export default node;
